import React, { useState } from 'react';

import { Form, Input } from 'antd';

import { EyeClosed, EyeOpen } from '../../../assets/icons';
import { passwordRegex, whiteSpaceRegex } from '../../../utils/Validations';
import { PASSWORD_VALIDATION } from '../../../utils/validationMessages';

const PasswordField = (props) => {
  const { name, password, setPassword, formInputClassName, autoCompletePassword, validation = true } = props;

  const form = Form.useFormInstance();

  const [passwordVisible, setPasswordVisible] = useState(false);

  const handlePasswordChange = (e) => {
    const trimmedPassword = e.target?.value?.trim() ?? '';
    setPassword(trimmedPassword);
    form?.setFieldsValue({ [name]: trimmedPassword });
    form?.validateFields([name]);
  };

  return (
    <>
      <Form.Item
        // validateTrigger="onBlur"
        className={formInputClassName}
        name={name}
        rules={[
          {
            required: true,
            validator: (_, value) => {
              if (whiteSpaceRegex.test(value)) {
                return Promise.reject(PASSWORD_VALIDATION.NO_SPACES);
              }
              if (validation) {
                if (passwordRegex.test(value)) {
                  if (value.length > 7) {
                    if (value.length > 20) {
                      return Promise.reject(PASSWORD_VALIDATION.MAX_LENGTH);
                    } else {
                      return Promise.resolve();
                    }
                  } else {
                    return Promise.reject(PASSWORD_VALIDATION.MAX_LENGTH);
                  }
                } else {
                  return Promise.reject(PASSWORD_VALIDATION.FORMAT);
                }
              } else {
                if (value.length > 0) {
                  return Promise.resolve();
                }
                return Promise.reject(PASSWORD_VALIDATION.REQUIRED);
              }
            },
          },
        ]}
      >
        <Input
          id='password'
          value={password}
          autoComplete={autoCompletePassword}
          type={passwordVisible ? 'text' : 'password'}
          suffix={passwordVisible ? <EyeClosed onClick={() => setPasswordVisible(false)} /> : <EyeOpen onClick={() => setPasswordVisible(true)} />}
          onChange={handlePasswordChange}
        />
      </Form.Item>
    </>
  );
};

export default PasswordField;
